<template>
    <div>
        <div v-for="(data,index) in formData" :key="index" class="form-group row">
            <label class="col-12" for="">保障階層第{{index+1}}層：</label>
            <div class="col-12">
                <div class="radio radio-inline ml-1">
                    <input 
                        type="radio" 
                        :id="`${isOther?'other-':''}type${index}-0`" 
                        v-model="data.type" 
                        value="0"
                        @input="changeType(index)"
                    >
                    <label :for="`${isOther?'other-':''}type${index}-0`">加入新階層</label>
                </div>
                <div class="radio radio-inline">
                    <input 
                        type="radio" 
                        :id="`${isOther?'other-':''}type${index}-1`" 
                        v-model="data.type" 
                        value="1" 
                        :disabled="getIsSelectDisabled(index)"
                    >
                    <label :for="`${isOther?'other-':''}type${index}-1`">選擇現有階層</label>
                </div>
            </div>
            <!-- 加入新階層 -->
            <template v-if="data.type === '0'">
                <div class="col-4 pr-0">
                    <input 
                        class="form-control"
                        :class="data.isCodeInputInvalid ? 'is-invalid' : ''"
                        v-model="data.code"
                        type="text"
                        placeholder="請輸入代碼"
                    >
                </div>
                <div class="col-8">
                    <input
                        class="form-control"
                        :class="data.isCategoryInputInvalid ? 'is-invalid' : ''"
                        v-model="data.category"
                        type="text"
                        placeholder="請輸入中文名稱"
                    >
                </div>
            </template>
            <!-- 選擇現有階層 -->
            <template v-else>
                <div class="col-12">
                    <select 
                        class="form-control form-control-inline form-large m-0 w-100"
                        :class="data.isSelectInvalid ? 'is-invalid' : ''"
                        v-model="data.value"
                        :disabled="getIsSelectDisabled(index)"
                    >
                        <option 
                            v-for="(option, idx) in getOptions(index)" 
                            :value="option.value" 
                            :key="`option-${idx}-${option.code}`"
                        >{{ option.code }} {{ option.category }}</option>
                    </select>
                </div>
            </template>
        </div>
        <div v-if="!isOther" class="form-group row">
            <label class="col-12" for="code">中項保障群組：</label>
            <div class="col">
                <report-setting-coverage-select :value="coverageData" />
            </div>
            <div class="col flex-grow-0 pl-0">
                <button  
                    class="btn btn-default btn-sm mx-0"
                    style="width:52px"
                    :disabled="!coverageData.code"
                    @click.stop.prevent="$emit('showMidCoverageInfo', coverageData)"
                >查詢</button>
            </div>
            <div class="col-12">
                <label for="hasDetail">是否有特殊條件：</label>
                <div class="radio radio-inline ml-1">
                    <input type="radio" id="hasDetailY" v-model="hasDetail" value="Y">
                    <label for="hasDetailY">是</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" id="hasDetailN" v-model="hasDetail" value="N">
                    <label for="hasDetailN">否</label>
                </div>
            </div>
            <template v-if="hasDetail === 'Y'">
                <label class="col-12" for="code">關聯特殊條件：</label>
                <div class="col">
                    <report-setting-coverage-select isdetail :value="detailData" />
                </div>
                <div class="col flex-grow-0 pl-0">
                    <button  
                        class="btn btn-default btn-sm mx-0"
                        style="width:52px"
                        :disabled="!detailData.code"
                        @click.stop.prevent="$emit('showSpecialConditionInfo', detailData)"
                    >查詢</button>
                </div>
            </template>
        </div>
        <div class="form-group row">
            <div class="col text-red">{{ errorInfo }}</div>
            <div class="col flex-grow-0 pl-0">
                <!-- 其他保障按鈕 -->
                <button 
                    v-if="isOther"
                    class="btn btn-primary btn-sm mx-0"
                    style="width:52px"
                    :disabled="data.length > 0"
                    @click.stop.prevent="doCreate()"
                >加入</button>
                <!-- 一般保障按鈕 -->
                <button 
                    v-else 
                    class="btn btn-primary btn-sm mx-0"
                    style="width:82px" 
                    :disabled="!coverageData.code || (hasDetail === 'Y' && !detailData.code)"
                    @click.stop.prevent="doCreate()"
                >新增一筆</button>
            </div>
        </div>
    </div>
</template>

<script>
import ReportSettingCoverageSelect from './ReportSettingCoverageSelect.vue';

export default {
    name: "ReportSettingForm",
    components: { ReportSettingCoverageSelect },
    props: {
        data: {
            type: Array,
            require: false,
            default: () => [] 
        },
        isOther: { 
            type: Boolean,
            default: false,
        },
        shellLevel: {
            type: Number,
            default: 1,
        },
        sumPosition: {
            type: String,
            default: "0",
        },
        settings: {
            type: Array, 
            default: () => [] 
        },
    },
    data() {
        return {
            formData: [],
            code: "",
            category: "",
            coverageData: {
                code:"",
                codename:"",
            },
            detailData: {
                code:"",
                codename:"",
            },
            hasDetail: "N",
            errorInfo: "",
            smallCategoryShowModalOpen: false,
            midShowData: { bigName: "", midCode: "", midName: "" },
            //存放保障細項
            smallCategory: [],
        };
    },
    methods: {
        init() {
            if (this.data.length == 0) {
                if (this.isOther) {
                    let level = this.sumPosition === '1' ? this.shellLevel - 1 : this.shellLevel;
                    for (let idx = 0; idx < level; idx++) {
                        this.formData.push({
                            type: '0',
                            code: 'G',
                            category: '其他保障',
                            isSelectInvalid: false,
                            isCodeInputInvalid: false,
                            isCategoryInputInvalid: false,
                        })
                    }
                } else {
                    for (let idx = 0; idx < this.shellLevel; idx++) {
                        this.formData.push({
                            type: this.settings.length > 0 ? '1' : '0',
                            code: '',
                            category: '',
                            value: '',
                            isSelectInvalid: false,
                            isCodeInputInvalid: false,
                            isCategoryInputInvalid: false,
                        })
                    }
                }
            } else {
                this.formData = this.data
                for (let idx = 0; idx < this.formData.length; idx++) {
                    this.formData[idx]['value'] = this.formData[idx].code+this.formData[idx].category
                    this.formData[idx]['type'] = this.formData.length - 1 == idx ? '0' : '1'
                    this.formData[idx]['isSelectInvalid'] = false
                    this.formData[idx]['isCodeInputInvalid'] = false
                    this.formData[idx]['isCategoryInputInvalid'] = false
                }
            }
        },
        getIsSelectDisabled(index) {
            if (this.isOther) {
                if (this.formData.length - 1 == index) return true;
            } else {
                let data = this.settings;
                for (let i = 0; i <= index; i++) {
                    if (i != 0) {
                        let node = data.find(x => x.code+x.category == this.formData[i-1].value)
                        if (node) {
                            data = node.children;
                        } else {
                            return true;
                        }
                    }
                    if (data.length == 0) return true;
                }
            }
            return
        },
        changeType(index) {
            // 當前一層選擇加入新階層時，下層也僅能選擇加入新階層
            for (let i = index+1; i < this.formData.length; i++) {
                this.formData[i].type = '0'
            }
        },
        getOptions(index) {
            // 尋找下層的現有階層
            let result = [];
            let data = this.settings;
            if (index != 0) {
                for (let i = 0; i < index; i++) {
                    let node = data.find(x => x.code+x.category == this.formData[i].value)
                    if (node) {
                        data = node.children;
                    } else {
                        return result;
                    }
                }
            }
            for (let i in data) {
                result.push({
                    code: data[i].code,
                    category: data[i].category,
                    value: data[i].code+data[i].category,
                })
            }
            return result;
        },
        doCreate() {
            const INPUT_EMPTY_ERROR = '階層代碼和名稱不得同時為空';
            const SELECT_EMPTY_ERROR = '階層必須選擇';
            const CODE_ERROR = '階層代碼格式錯誤';
            const CATEGORY_REPEATED_ERROR = '階層名稱不得重複';
            const COVERAGE_REPEATED_ERROR = '中項保障不得重複加入';
            let nodelist = this.settings;
            let node;
            let errorInfoList = [];
            this.errorInfo = "";
            for (let i in this.formData) {
                let item = this.formData[i]
                item.isCodeInputInvalid = false
                item.isCategoryInputInvalid = false
                item.isSelectInvalid = false
                if (item.type === '0') {
                    item.value = item.code+item.category
                    if (item.code === '' && item.category === '') {
                        // 階層代碼和名稱不得同時為空
                        !errorInfoList.includes(INPUT_EMPTY_ERROR) && errorInfoList.push(INPUT_EMPTY_ERROR)
                        item.isCodeInputInvalid = true
                        item.isCategoryInputInvalid = true
                    } else {
                        if (item.code != '') {
                            // 階層代碼有輸入時，要驗證格式為英數
                            let regex = new RegExp("[a-zA-Z0-9]");
                            if (!regex.test(item.code)) {
                                !errorInfoList.includes(CODE_ERROR) && errorInfoList.push(CODE_ERROR)
                                item.isCodeInputInvalid = true
                            }
                        }
                        // console.log("nodelist.find", nodelist.find(x => x.category == item.category))
                        if (nodelist && nodelist.find(x => x.category == item.category)) {
                            !errorInfoList.includes(CATEGORY_REPEATED_ERROR) && errorInfoList.push(CATEGORY_REPEATED_ERROR)
                            item.isCategoryInputInvalid = true
                        }
                    }
                } else {
                    if (item.value === '') {
                        !errorInfoList.includes(SELECT_EMPTY_ERROR) && errorInfoList.push(SELECT_EMPTY_ERROR)
                        item.isSelectInvalid = true
                    }
                }
                
                node = nodelist ? nodelist.find(x => x.code+x.category == item.value) : null
                nodelist = node ? node.children : null
            }
            if (!this.isOther && node && nodelist) {
                let detailCode = this.hasDetail === "Y" ? this.detailData.code : null
                if (nodelist.find(x => x.coverage == this.coverageData.code && x.detail == detailCode)) {
                    errorInfoList.push(COVERAGE_REPEATED_ERROR)
                }
            }
            if (errorInfoList.length > 0) {
                this.errorInfo = errorInfoList.join("、");
                return;
            }
            this.$emit('create', this.formData);
            this.addSettingNode();
        },
        addSettingNode() {
            let nodelist = this.settings;
            let node;
            for (let i in this.formData) {
                let item = this.formData[i]
                node = nodelist.find(x => x.code+x.category == item.value)
                if (node) {
                    nodelist = node.children;
                } else {
                    let newNode = {
                        code: item.code,
                        category: item.category,
                        children: [],
                        isother: this.isOther,
                    };
                    nodelist.push(newNode);
                    node = newNode;
                    nodelist = newNode.children;
                }
                
                if (this.isOther) node.isother = true;
            }
            if (!this.isOther) {
                let hasDetail = this.hasDetail === 'Y'
                let newNode = {
                    code: hasDetail ? this.coverageData.code + "_" + this.detailData.code : this.coverageData.code,
                    category: hasDetail ? this.coverageData.codename + "_" + this.detailData.codename : this.coverageData.codename,
                    coverage: this.coverageData.code,
                    coveragename: this.coverageData.codename,
                }
                if (hasDetail) {
                    newNode.detail = this.detailData.code;
                    newNode.detailname = this.detailData.codename;
                }
                nodelist.push(newNode);
            }
        },
    },
    mounted() { 
       this.init();
    },
};
</script>
